module.exports = __webpack_public_path__ + "img/a friend in need for all your digital marketing needs.d3934e7d.jpg";